function AppImages(imgProps) {
  return <img alt="Edpodia" {...imgProps} />;
}

export default AppImages;
